import { Controller } from "@hotwired/stimulus";

// The standalone Other Document uploader carries its outcome in the URL (upload_success/
// upload_alert), not a session flash -- see admin/documents_controller.rb. flash.now keeps that
// from persisting server-side, but the params themselves stay in the address bar after the page
// renders: a refresh or a copied/revisited link would re-satisfy the same params and re-report an
// old upload as newly finished. Stripping them from history right after the one render they're
// for is what keeps a reload from repeating it.
export default class extends Controller {
  connect () {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("upload_success") && !url.searchParams.has("upload_alert")) return;

    url.searchParams.delete("upload_success");
    url.searchParams.delete("upload_alert");
    window.history.replaceState(window.history.state, "", url.toString());
  }
}
